export const GET_COINS = 'GET_COINS';// 获取浪币列表

export const CREATE_COIN = 'CREATE_COIN';// 添加浪币套餐

export const UPDATE_COIN = 'UPDATE_COIN';// 修改浪币套餐

export const DELETE_COIN = 'DELETE_COIN';// 删除浪币套餐